module.exports = __webpack_public_path__ + "static/media/story-15.11a474cf.jpg";